import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { JwtModule } from '@auth0/angular-jwt';

import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { HomeComponent } from './components/home/home.component';
import { ContactComponent } from './components/contact/contact.component';
import { MethodsAnalytesComponent } from './components/methods-analytes/methods-analytes.component';
import { LoginComponent } from './components/login/login.component';
// import { RegisterComponent } from './components/register/register.component';
import { UpdateUserComponent } from './components/update-user/update-user.component';
import { SearchLabsComponent } from './components/searchLabs/searchLabs.component';
import { AuthGuard } from '@shared/auth/auth-guard';
import { LabUserMenuComponent } from './components/lab-user-menu/lab-user-menu.component';
import { RegisterLabComponent } from './components/register-lab/register-lab.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'contact', component: ContactComponent },
      { path: 'analytes', component: MethodsAnalytesComponent },
      { path: 'login', component: LoginComponent },
      { path: 'register-lab', canActivate: [AuthGuard], component: RegisterLabComponent },
      { path: 'searchLabs', component: SearchLabsComponent },
      { path: 'update-user', canActivate: [AuthGuard], component: UpdateUserComponent },
      {
        path: 'sessions',
        loadChildren: () => import('./components/sessions/sessions.module').then(m => m.SessionsModule),
      },
      {
        path: 'lab-user-menu',
        canActivate: [AuthGuard], 
        component: LabUserMenuComponent
      },
      {
        path: 'application-menu',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/application-menu/application-menu.module').then(m => m.ApplicationMenuModule)
      },
      {
        path: 'inspection',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/inspection/inspection.module').then(m => m.InspectionModule)
      },
      {
        path: 'ptMenu',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/ptMenu/ptMenu.module').then(m => m.PtMenuModule)
      },
    ]
  },
  { path: '**', redirectTo: 'home' },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      initialNavigation: !isIframe ? "enabledNonBlocking" : "disabled"
    })
  ],
  exports: [RouterModule],
  declarations: [
  ]
})

export class RoutesRoutingModule { }
